<template>
    <div>
        <h1>Reels</h1>
        <vs-prompt @cancel="val=''" blur @accept="acceptAlert" @close="close" :active.sync="activePrompt"
            accept-text="Add" title="Add New Reel">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Arabic Name" v-model="reel.ar_name" />
                <vs-input placeholder="English Name" v-model="reel.en_name" />

            </div>
        </vs-prompt>
         <vs-table :data="$store.state.reels.all.data">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center">
                    <div @click="$router.push({name:'reelsCreate'})"
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New Reel</span>
                    </div>
                    <div @click="$router.push({name:'reelsImport'})"
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
                        <feather-icon icon="LinkIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Import From Tiktok</span>
                    </div>
                </div>
                
            </div>
            <template #thead>
                <vs-th>Title</vs-th>
                <vs-th>User</vs-th>
                <vs-th>Comments</vs-th>
                <vs-th>Likes</vs-th>
                <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr v-for="(reel,index) in data" :key="index">
                        <vs-td>{{reel.content}}</vs-td>
                        <vs-td>{{reel.user.name}}</vs-td>
                        <vs-td>{{reel.comments_count}}</vs-td>
                        <vs-td>{{reel.likes_count}}</vs-td>
                        <vs-td class="whitespace-no-wrap">
                            <!-- <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click="edit(reel)" /> -->
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="openConfirm(reel)" />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <vs-pagination :total="$store.state.reels.all.last_page" v-model="page"></vs-pagination>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                page:1,
                select1: 2,
                activePrompt: false,
                delConfirm: false,
                val: '',
                def_reel: {
                    id: 0,
                    body: '',
                    media: ''
                },
                reel: {
                    id: 0,
                    body: '',
                    media: ''
                }
            }
        },
        watch:{
            page(val) {
                 var page = val;
                this.$store.dispatch('reels/fetchReels',{page})
            },
        },
        created() {
             var page = this.page;
            this.$store.dispatch('reels/fetchReels',{page})
        },
        methods: {
            openConfirm(reel) {
                this.reel=reel;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Delete reel`,
                    text: 'Are you sure to delete this item ?',
                    accept:this.del,
                    close:this.close
                })
            },
            acceptAlert(color) {
                const data = new FormData();
                data.append('id', this.reel.id);
                data.append('ar_name', this.reel.ar_name);
                data.append('en_name', this.reel.en_name);
                this.axios.post(`${this.$apiUrl}/reels`, data).then(res => {
                    this.reel = this.def_reel;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'reel Addedd',
                            text: res.data.response.en_name
                        })
                    }
                     var page = this.page;
                    this.$store.dispatch('reels/fetchReels',{page})
                })

            },
            close() {
                this.reel = this.def_reel;
            },
            edit(reel) {
                this.reel = reel;
                this.activePrompt = true;
            },
            del() {
                 this.axios.post(`${this.$apiUrl}/reels/delete/${this.reel.id}`).then(res => {
                    this.reel = this.def_reel;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'warning',
                            title: 'reel Deleted !',
                            text: res.data.response.en_name
                        })
                    }
                     var page = this.page;
                    this.$store.dispatch('reels/fetchReels',{page})
                })

            },
        }
    }
</script>
<style lang="scss">
    .con-exemple-prompt {
        padding: 10px;
        padding-bottom: 0px;

        .vs-input {
            width: 100%;
            margin-top: 10px;
        }

    }
</style>